<template>
  <div class="store">
    <header>
      <div class="banner">
        <h3>高性能融合型存储</h3>
        <h4>CompubiqStor</h4>
        <transition
          enter-active-class="animate__animated animate__bounceInDown"
          leave-active-class="animate__animated animate__fadeOut"
        >
          <div class="circle pa" v-show="isShow">
            <img src="@/assets/imgstore/store-banner-circle.png">
          </div>
        </transition>
        <transition
          enter-active-class="animate__animated animate__bounceInDown banner-equip"
          leave-active-class="animate__animated animate__fadeOut"
        >
          <div class="equip pa" v-show="isShow">
            <img src="@/assets/imgstore/store-banner-equip.png">
          </div>
        </transition>
      </div>
    </header>
    <div class="main">
      <section>
        <img src="@/assets/imgstore/main1.png">
        <h4>国产自主可控</h4>
        <p>采用华为TaiShan服务器作为存储自身硬件，<br/>信易达自主研发存储专用操作系统，<br/>内核经过高度精简，充分保障软件系统的<br/>稳定、安全、可靠</p>
      </section>
      <section>
        <img src="@/assets/imgstore/main2.png">
        <h4>融合型存储</h4>
        <p>多协议融合型存储；<br/>SAN支持iSER、SRP、FC、iSCSI<br/>NAS支持NFS、NFSoRDMA、Samba<br/>并行支持Lustre、BeeGFS</p>
      </section>
      <section>
        <img src="@/assets/imgstore/main3.png">
        <h4>极致性能</h4>
        <p>控制器最大支持48核处理器、2TB内存、<br/>支持业内最高水平接口类型，<br/>32Gbps FC / 100Gbps Ethernet / <br/>200Gbps Infiniband</p>
      </section>
    </div>
    <div class="list">
      <h3>技术规格</h3>
      <table border="1" cellspacing="0">
        <col width="140px">
        <col width="300px">
        <col width="300px">
        <col width="300px">
        <tr height="100px" class="header">
          <td>型号</td>
          <td>
            <img
              src="@/assets/imgstore/list1.png"
              alt=""
              style="width: 60%;height: auto;display: block;margin: auto;padding-top: 120px;margin-bottom: 5px;"
            >
            <span>U3100</span>
          </td>
          <td>
            <img
              src="@/assets/imgstore/list2.png"
              alt=""
              style="width: 60%;height: auto;display: block;margin: auto;padding-top: 60px;"
            >
            <span>U3200</span>
          </td>
          <td>
            <img
              src="@/assets/imgstore/list3.png"
              alt=""
              style="width: 60%;height: auto;display: block;margin: auto;padding-top: 20px;"
            >
            <span>U5000</span>
          </td>
        </tr>
        <tr height="37px">
          <td class="header">控制器数量</td>
          <td>1</td>
          <td colspan="2">2</td>
        </tr>
        <tr height="37px">
          <td class="header">处理器</td>
          <td colspan="2">鲲鹏920（24核 2.6GHz）</td>
          <td>鲲鹏920（48核 2.6GHz）</td>
        </tr>
        <tr height="37px">
          <td class="header">缓存</td>
          <td colspan="2">32G-1T/每控制器</td>
          <td>128G-2T/每控制器</td>
        </tr>
        <tr height="37px">
          <td class="header">Raid级别</td>
          <td colspan="3">0、1、5、6、10、50、60</td>
        </tr>
        <tr height="37px">
          <td class="header">支持存储协议</td>
          <td colspan="3">SRP、FC、iSER、iSCSI、NFS、NFSoRDMA、Samba</td>
        </tr>
        <tr height="37px">
          <td class="header">接口类型</td>
          <td colspan="3">8/16/32Gbps FC 1/10/100Gbps Ethernet 56/100/200Gbps Infiniband</td>
        </tr>
        <tr height="37px">
          <td class="header">磁盘类型</td>
          <td colspan="3">NVMe SSD、SSD、SAS、SATA（支持混插）</td>
        </tr>
        <tr height="37px">
          <td class="header">双控最大磁盘数</td>
          <td>1908</td>
          <td colspan="2">3816</td>
        </tr>
        <tr height="37px">
          <td class="header">扩展接口</td>
          <td colspan="3">12Gb/s Mini SAS 3.0</td>
        </tr>
        <tr height="37px">
          <td class="header">扩展柜支持</td>
          <td colspan="3">2U12/2U24/5U84/4U106 2.5/3.5英寸盘位</td>
        </tr>
        <tr height="37px">
          <td class="header">高级功能</td>
          <td colspan="3" class="table-last-wrapper">
            <div class="table-last">
              <span>·重复数据删除</span>
              <span>·虚拟磁带</span>
              <span>·压缩</span>
              <span>·精简置备</span>
            </div>
            <div class="table-last">
              <span>·快照</span>
              <span>·ALUA</span>
              <span>·克隆</span>
              <span>·远程复制</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="cert-wrapper">
      <h3>技术认证</h3>
      <div class="cert">
        <div>
          <img src="@/assets/imgstore/cert1.png">
        </div>
        <div>
          <img src="@/assets/imgstore/cert2.png">
        </div>
        <div>
          <img src="@/assets/imgstore/cert3.png">
        </div>
        <div>
          <img src="@/assets/imgstore/cert4.png" style="width: auto; height: 60%;margin-top: 50px;">
        </div>
      </div>
    </div>
    <div class="caser-warpper">
      <div class="caser">
        <h2>客户案例</h2>
        <div class="case">
          <a href="javascript:void(0)">
            <img src="@/assets/imgstore/store-custom1.png">
          </a>
          <a href="javascript:void(0)">
            <img src="@/assets/imgstore/school-hn.png">
          </a>
          <a href="javascript:void(0)">
            <img src="@/assets/imgstore/school-nj.png">
          </a>
          <a href="javascript:void(0)">
            <img src="@/assets/imgstore/store-custom3.png">
          </a>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-cont">
        <div class="logo">
          <img src="@/assets/imgs/logo.png">
        </div>
        <div class="contact">
          <h4>联系我们</h4>
          <p>地址：南京市江北新区腾飞大厦A座4楼</p>
          <p>电话：025-68155007</p>
        </div>
        <div class="qr">
          <img class="tu" src="@/assets/imgs/home-qr.png">
          <br>
          <span class="spa">关注我们</span>
        </div>
      </div>
    </div>
    <div class="footer footer2">
      <p>版权所有 © 南京信易达计算技术有限公司 <a style="color: rgba(255,255,255, .4);" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备2021021510号-1</a> 苏公网安备 0000000000号</p>
    </div>
  </div>
</template>

<script>
import store from "../store.js";
import "animate.css";
export default {
  name: "home",
  data() {
    return {
      isShow: false,
      state: store.state,
      isShowContaner: false,
    };
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0);
      this.isShow = true;
    }, 100);
  },
  watch: {
    "state.scrollTop"(val, oldVal) {
      console.log("home scrollTop:", val, oldVal);
      this.isShow = val < 700;

      this.isShowContaner = val > 1000 && val < 2000;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.store {
  header {
    height: 430px;
    background: #006BBF linear-gradient(to right, #348ad1, #0073CE);
  }
  .banner {
    width: 1200px;
    text-align: center;
    margin: 0 auto;
    padding-top: 100px;
    height: 330px;
    position: relative;
    h3, h4 {
      font-size: 50px;
      color: #fff;
      text-align: left;
    }
    h4 {
      opacity: .8;
    }
    .circle {
      right: -100px;
      top: 0;
      width: 698px;
      height: 380px;
      z-index: 1;
      overflow: hidden;
      padding-top: 50px;
      img {
        width: 90%;
        animation: imgRotate 10s infinite linear;
        transform-origin: center center;
      }
    }
    .equip {
      position: absolute;
      bottom: -50px;
      right: -20px;
      width: 575px;
      height: 339px;
      z-index: 2;
      img {
        width: 100%;
      }
    }
    .banner-equip {
      animation-delay: 300ms;
    }
  }
}
.main {
  display: flex;
  justify-content: space-around;
  width: 1200px;
  margin: 100px auto;
  section {
    width: 29%;
    padding: 3%;
  }
  section img {
    width: 30%;
    margin: auto;
    display: block;
    margin-bottom: 5%;
  }
  section h4 {
    text-align: center;
    font-size: 18px;
    color: #465373;
    margin-bottom: 3%;
  }
  section p {
    line-height: 1.6em;
    color: #465373;
    text-align: center;
  }
}

.list {
  width: 1200px;
  margin: 0 auto;
  h3 {
    text-align: center;
    color: #465373;
    font-size: 28px;
    margin: 7% auto 2%;
  }
  table {
    .header {
      background: #f0f6fe;
    }
    width: 100%;
    border: 1px solid #a7d6fc;
    tr td:first-child {
      color: #465373;
      font-weight: 600;
    }
    td {
      border: 1px solid #a7d6fc;
      text-align: center;
      color: #465373;
      line-height: 50px;
    }
    .table-last-wrapper {
      padding: 10px 0;
    }
    .table-last {
      display: flex;
      justify-content: center;
      span {
        display: inline-block;
        width: 150px;
        text-align: left;
        line-height: 25px;
      }
    }
  }
}

.cert-wrapper {
  align-content: center;
  margin: 0 auto;
  width: 1200px;
  padding: 100px 0 100px;
  height: 400px;
  text-align: center;
  h3 {
    padding-bottom: 40px;
    font-size: 35px;
    color: #465373;
  }
  .cert {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    background: #fff;
    box-shadow: 0 0 10px #cccccc;
  }
  .cert div {
    flex-grow: 1;
    padding: 30px;
    height: 300px;
    text-align: center;
  }
  .cert div img {
    height: 100%;
    cursor: pointer;
    transition: 500ms all;
    &:hover {
      transform: scale(1.5);
    }
  }
}

.caser-warpper {
  width: 100%;
  height: 400px;
  background: #f8f6f6;
  padding: 50px 0 0;
}
.caser {
  width: 1200px;
  margin: 0 auto;
  h2 {
    text-align: center;
    font-size: 35px;
    color: #465373;
    padding-bottom: 50px;
  }
  .case {
    display: flex;
    justify-content: space-between;
    align-items: center;
    a {
      transition: 500ms all;
      cursor: pointer;
    }
    a:hover {
      transform: scale(1.2);
    }
  }
  .case img {
    width: 310px;
  }
}

.footer {
  background: #2b2b2b;
  // height: 100px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  .footer-cont {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    .logo {
      width: 130px;
      padding: 20px 0 0;
      img {
        width: 120px;
        background: rgba(255, 255, 255, .9);
        padding: 5px 8px;
        border-radius: 5px;
      }
    }
    .contact {
      flex: 1;
      padding: 20px 0 0 10%;
      line-height: 26px;
      h4 {
        color: rgba(255, 255, 255, 0.69);
        font-size: 16px;
        padding-bottom: 10px;
      }
    }
    .qr {
      width: 80px;
      padding: 20px 0;
      text-align: center;
      img {
        width: 80px;
        margin-bottom: 10px;
      }
    }
  }
}
.footer2 {
  background: #2b2b2b;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
}

@keyframes imgRotate {
  0 {
    opacity: 1;
    transform: rotate(0deg);
  }
  50% {
    opacity: 0.7;
    transform: rotate(180deg) scale(1.1);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg);
  }
}

@keyframes shine {
  0 {
    opacity: 1;
  }
  50% {
    opacity: 0.9;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Store.vue